import { SMS_ACTION_TYPES, SEND_SMS_ACTION_TYPES } from '../actions/sms'

const defaultState = {
  fetching: false,
  list: [],
  error: null,
  sending: false,
  sendError: null,
}

const { SMS_FAILURE, SMS_REQUEST, SMS_SUCCESS } = SMS_ACTION_TYPES

const { SEND_SMS_FAILURE, SEND_SMS_REQUEST, SEND_SMS_SUCCESS } = SEND_SMS_ACTION_TYPES

const smsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case SMS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: null,
      }
    }

    case SMS_SUCCESS: {
      return {
        ...state,
        fetching: false,
        list: (action.payload.sms || []).reverse(),
      }
    }

    case SMS_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: action.error,
      }
    }

    case SEND_SMS_REQUEST: {
      return {
        ...state,
        sending: true,
        sendError: null,
      }
    }

    case SEND_SMS_SUCCESS: {
      return {
        ...state,
        sending: false,
        sendError: null,
        list: [...state.list, action.payload.smsMessage],
      }
    }

    case SEND_SMS_FAILURE: {
      return {
        ...state,
        sending: false,
        sendError: action.error,
      }
    }
    default:
      return state
  }
}

export default smsReducer
